import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConflictItem } from './configit-types.interface';

@Component({
    selector: 'app-conflicting-value-dialog',
    templateUrl: 'conflicting-value-dialog.component.html',
    styleUrls: ['./conflicting-value-dialog.component.scss'],
})
export class ConflictingValueDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public items: ConflictItem[]) {}
}
